// extracted by css-extract-rspack-plugin
export default {"a0":"RecommendedPodcasts-cls1_xP3","cls1":"RecommendedPodcasts-cls1_BaY","cls2":"RecommendedPodcasts-cls2_2G2 RecommendedPodcasts-cls1_BaY"};